import { useQueryClient } from '@tanstack/react-query';
import { WifiOff } from 'lucide-react';
import { useOnline } from '@/api/query';
import { de } from '@/i18n/de';
import { format } from '@/i18n/format';
import { t } from '@/i18n/t';

/**
 * Hinweisleiste ohne Verbindung: die zuletzt geladenen Daten bleiben sichtbar (Zwischenspeicher), Handlungen
 * sind gesperrt. Die Uhrzeit ist der jüngste Stand aller Abfragen. Die äußere Fläche ist immer eingebaut,
 * damit Vorlesegeräte das Erscheinen höflich ansagen.
 */
export function OfflineBar() {
  const online = useOnline();
  const queryClient = useQueryClient();
  let text: string = de.states.offlineNoData;
  if (!online) {
    const latest = Math.max(
      0,
      ...queryClient
        .getQueryCache()
        .getAll()
        .map((query) => query.state.dataUpdatedAt),
    );
    if (latest > 0) {
      text = t('states.offline', { time: format.time(new Date(latest)) });
    }
  }
  return (
    <div role="status">
      {online ? null : (
        <p className="flex items-center gap-2 bg-surface-sunken px-4 py-2 text-body text-ink">
          <WifiOff aria-hidden="true" className="size-5 shrink-0" />
          <span>{text}</span>
        </p>
      )}
    </div>
  );
}
